<script setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import {useAuthStore} from "@/store/auth.module";

const router = useRouter()
const tmpToken = new URLSearchParams(window.location.search).get('tmpToken')
const signed = new URLSearchParams(window.location.search).get('signed') === 'true'
const redirectPath = sessionStorage.getItem('oauth2_return_path') || '/'
sessionStorage.removeItem('oauth2_return_path');
const VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;


onMounted(async () => {
  try {
    const response = await axios.get(`/v1/oauth2/login`, {
      baseURL: `${VUE_APP_API_BASE_URL}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tmpToken}`,
      },
    })
    if (response.data.signed) {
      const authStore = useAuthStore();
      authStore.snsLogin(response.data.loginResDto);
      await router.replace(redirectPath)

    } else {
      // 가입 폼 보여주기
      sessionStorage.setItem('oauth2_return_dto', JSON.stringify(response.data));
      await router.replace({name:'Signup'})
    }

  } catch (e) {
    console.error(e)
    alert('로그인 실패')
  }
})
</script>
